<template>

  <Ftp />
 
</template>

<script>
import Ftp from '../components/pratiche/Ftp.vue'

export default {
  components: {
    Ftp

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

